<template>
  <Modal :footer-hide="true" :mask-closable="false" v-model="show" :width="600" @on-cancel="clearFrom()">
    <div class="QHaccountEnter">
      <h1>注册账号</h1>
      <dl v-if="false">
        <dt>所属城市</dt>
        <dd>
          <div class="flex-between">
            <Input placeholder="选择地址" v-model="form.addressFull" :readonly="true" />
            <Button slot="append" @click="hiAddressPop()" type="info" style="margin-left: 5px">选择</Button>
          </div>
        </dd>
      </dl>
      <dl>
        <dt>注册手机</dt>
        <dd>
          <Input v-model="form.account" placeholder="只能是11位手机号码" maxlength="11">
            <Button @click="sendVerifySms()" slot="append">
              <template v-if="count < 1">发送验证码</template>
              <template v-else>重新发送({{ count }}s)</template>
            </Button>
          </Input>
        </dd>
      </dl>
      <dl>
        <dt>手机验证码</dt>
        <dd><Input v-model="form.code" placeholder="验证码有效期5分钟" maxlength="4" /></dd>
      </dl>
      <dl>
        <dt>设置密码</dt>
        <dd><Input v-model="form.password" type="password" placeholder="密码6-16位之间,必须含字母" maxlength="16" /></dd>
      </dl>
      <dl>
        <dt>确认密码</dt>
        <dd><Input v-model="form.repassword" type="password" placeholder="和设置密码一致" maxlength="16" /></dd>
      </dl>
      <Button type="primary" class="QHbtnBig" @click="saveOk()">立即注册</Button>
      <div class="formGroup flex-between" style="margin-top: 20px">
        <span></span>
        <div>
          <span class="QHset" @click="$emit('hello', 'QHlogin')">直接登录</span>
          <span class="QHset" @click="$emit('hello', 'QHforget')">找回密码</span>
        </div>
      </div>
    </div>
    <!--组件层-->
  </Modal>
</template>

<script>
import data from "./data.js";
export default {
  // +----------------------------------------------------------------------
  // | Desc:data
  // +----------------------------------------------------------------------
  data() {
    return {
      loading: false,
      show: false,
      timer: "",
      count: 0,
      form: { ...data.data },
    };
  },
  methods: {
    // +----------------------------------------------------------------------
    // | @Des:saveOk
    // +----------------------------------------------------------------------
    saveOk() {
      //综合赋值验证
      var parameter = this.$isSubmitValidGetPram(this, data);
      if (!parameter) {
        return;
      }

      //参数整合与接口
      var that = this;
      var https = {
        isLoading: "isLoadingStr",
        api: this.$api.resigister,
        parameter: parameter,
      };
      this.$httpsApi(https, function (res) {
        that.clearFrom();
        that.show = false;
        res.toolType = "QHzhuce";
        that.$emit("success", res);
      });
    },

    // +----------------------------------------------------------------------
    // | @Des:sendVerifySms
    // +----------------------------------------------------------------------
    sendVerifySms() {
      let _this = this;
      if (_this.loading) {
        _this.$msg("请不要重复发送", "error");
        return;
      }
      if (!_this.$isTel(_this.form.account)) {
        _this.$msg("手机号码输入错误", "error");
        return;
      }
      _this.loading = true;
      _this.$loading(true, "正在发送");

      //请求
      _this.$api
        .sendVerifySmsZhuce({
          tel: _this.form.account,
        })
        .then((res) => {
          _this.$loading(false);
          if (res.code == 0) {
            _this.form.token = res.data;
            _this.getCode();
            _this.$msg(res.msg, "success");
          } else {
            _this.loading = false;
            _this.$msg(res.msg, "error");
          }
        });
    },

    // +----------------------------------------------------------------------
    // | @Des:getCode
    // +----------------------------------------------------------------------
    getCode: function () {
      const TIME_COUNT = 60;
      var _this = this;
      if (!_this.timer) {
        _this.count = TIME_COUNT;
        _this.timer = setInterval(() => {
          if (_this.count > 1 && this.count <= TIME_COUNT) {
            _this.count--;
          } else {
            clearInterval(_this.timer);
            _this.loading = false;
            _this.count = 0;
            _this.timer = null;
          }
        }, 1000);
      }
    },

    // +----------------------------------------------------------------------
    // | Desc:清理表单
    // +----------------------------------------------------------------------
    clearFrom() {
      this.loading = false;
      this.show = false;
      this.form = { ...data.data };
      this.form.id = "";
      this.form.password = "";
    },
  },
};
</script>
<style>
.QHaccountEnter {
  margin: 20px;
}
.QHaccountEnter h1 {
  text-align: center;
  font-size: 24px;
  font-weight: 700;
  font-weight: normal;
}
.QHaccountEnter dt {
  font-size: 15px;
  margin-bottom: 5px;
}
.QHaccountEnter dl {
  margin-bottom: 25px;
}
</style>
